<template>
  <common-dialog ref="dialog" width="400px" title="延迟收货" id-key="id" :data="data" :save-func="saveDataFunc"
    @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="延迟天数" label-width="75px">
        <el-select v-model="data.days" :clearable="false">
          <el-option label="3天" :value="3"></el-option>
          <el-option label="5天" :value="5"></el-option>
          <el-option label="7天" :value="7"></el-option>
          <el-option label="10天" :value="10"></el-option>
          <el-option label="30天" :value="30"></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/wx/order').default,
      data: {
        id: 0,
        days: 3
      },
    };
  },
  mounted() { },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.postponeConfirmTime(this.data).then(res => {
          if (res.errorMessage) {
            resolve({ Code: 1, Msg: res.errorMessage })
          } else {
            resolve({ Code: 0, Msg: null })
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
  },
};
</script>
